import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFreedesktopDotOrgComponent } from './simple-icons-freedesktop-dot-org.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFreedesktopDotOrgComponent ],
    exports:      [ SimpleIconsFreedesktopDotOrgComponent ],
    bootstrap:    []
})
export class SimpleIconsFreedesktopDotOrgModule {}
